import { render, staticRenderFns } from "./PageFive.vue?vue&type=template&id=ec20b31e&scoped=true&"
import script from "./PageFive.vue?vue&type=script&lang=js&"
export * from "./PageFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec20b31e",
  null
  
)

export default component.exports